import { render } from "./AvailablePackage.vue?vue&type=template&id=284582f0"
import script from "./AvailablePackage.vue?vue&type=script&lang=js"
export * from "./AvailablePackage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__